import { ASSETS } from "@/data/site";
import { Reveal, SectionLabel } from "@/components/Reveal";

export const SmartControl = () => (
  <section className="bg-brand-blue py-20 md:py-28 overflow-hidden">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 lg:grid-cols-2 lg:gap-16 lg:px-8">
      <Reveal>
        <SectionLabel dark>Smart Control</SectionLabel>
        <h2 className="mt-5 font-display text-3xl md:text-4xl font-bold tracking-tight text-white text-balance">
          Intelligent zoning with AirTouch
        </h2>
        <p className="mt-5 text-lg text-slate-300 leading-relaxed">
          Take full control of your comfort with AirTouch smart climate control. Manage temperatures room-by-room, set schedules, and only condition the spaces you're using — reducing energy waste and keeping everyone comfortable.
        </p>
        <ul className="mt-7 space-y-3 text-slate-300">
          {["Room-by-room zoning", "Simple touchscreen & app control", "Smart scheduling for efficiency", "Works with compatible ducted systems"].map((x) => (
            <li key={x} className="flex items-center gap-3">
              <span className="h-1.5 w-1.5 rounded-full bg-brand-gold" /> {x}
            </li>
          ))}
        </ul>
        <img src={ASSETS.airtouchPanel} alt="AirTouch smart control panel and app" loading="lazy" className="mt-8 h-auto w-full max-w-md rounded-xl" />
      </Reveal>
      <Reveal delay={0.1}>
        <div className="rounded-3xl bg-white/5 p-6 backdrop-blur">
          <img src={ASSETS.airtouchHome} alt="AirTouch smart home zoning layout" loading="lazy" className="w-full rounded-xl" />
        </div>
      </Reveal>
    </div>
  </section>
);
